import { Button, Tooltip } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDoLogout } from "src/utils/useDoLogout";

const LogOutButton = ({ color }: { color: string }) => {
  // Use function doLogOut from custom hook useDoLogout
  const doLogOut = useDoLogout();
  return (
    <Tooltip title="Log out" arrow placement="top">
      {/* <Button sx={{ color: "#ffffff", p: 0 }} onClick={doLogOut}> */}
      <LogoutIcon sx={{ color: color, p: 0 }} onClick={doLogOut} />
      {/* </Button> */}
    </Tooltip>
  );
};

export default LogOutButton;
